import fetchApi from '../../Services/requests';
import { PurchasesDataUrl } from '../../Routes/purchases.route';
import { CustomerFactorType } from '../../Types/purchases.type';

export const getPurchasesDataAction = async (
  set,
  body: {
    clubBranchId: number;
    skip: number;
    take: number;
  }
): Promise<CustomerFactorType[]> => {
  set((state) => ({
    purchasesData: state.purchasesData,
    purchasesLoading: true,
    purchasesError: false
  }));

  const response = await fetchApi(PurchasesDataUrl(), body);

  if (response?.ok) {
    set((state) => ({
      purchasesData: {
        ...response.data,
        customerFactorBriefList: (
          state.purchasesData?.customerFactorBriefList || []
        ).concat(response.data.customerFactorBriefList)
      },
      purchasesLoading: false,
      purchasesError: false
    }));
    return response.data.customerFactorBriefList;
  } else {
    set({
      purchasesLoading: false,
      purchasesError: true
    });
    return null;
  }
};

export const setHasMoreDataAction = (set, hasMore: boolean): void => {
  set({ hasMoreData: hasMore });
};
